import { Directive,forwardRef } from '@angular/core';
import { AbstractControl,NG_VALIDATORS,Validator } from '@angular/forms';
import moment from 'moment';

@Directive({
  selector:
    '[validateAfterToday][formControlName],[validateAfterToday][formControl],[validateAfterToday][ngModel]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => AfterTodayValidator),
      multi: true,
    },
  ],
  standalone: true,
})
export class AfterTodayValidator implements Validator {
  today: moment.Moment = moment().add(-1, 'days');
  constructor() {}

  validate(c: AbstractControl): { [key: string]: any } {
    const v = moment(c.value, 'YYYY-MM-DD');

    // value not equal
    if (v < this.today) {
      return {
        afterToday: true,
      };
    }
    return null;
  }
}
